import { render } from "./bookingResult.vue?vue&type=template&id=5696d158&scoped=true"
import script from "./bookingResult.vue?vue&type=script&lang=js"
export * from "./bookingResult.vue?vue&type=script&lang=js"

import "./bookingResult.vue?vue&type=style&index=0&id=5696d158&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5696d158"

export default script